export default {
  path: '/sp_users',
  component: () => import('@/layouts/PublicLayout'),
  children: [
    {
      path: 'signin',
      component: () => import('@/views/sp_users/Signin'),
      meta: {
        title: '运营商用户登录'
      }
    },
    {
      path: 'profile',
      component: () => import('@/views/sp_users/Profile'),
      meta: {
        title: '运营商用户中心'
      }
    }
  ]
}
